import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@models/store';
import { AuthService } from '@services/auth.service';
import { NotificationService } from '@services/notification.service';
import { StoreService } from '@services/store.service';

@Component({
  selector: 'app-location-settings',
  templateUrl: './location-settings.component.html',
  styleUrls: ['./location-settings.component.css'],
})
export class LocationSettingsComponent implements OnInit, OnDestroy {
  store: Store = null;
  saving = false;
  private stores: Store[] = [];
  private storeSub: Subscription;

  constructor(
    private storeService: StoreService,
    private notification: NotificationService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.storeSub = this.auth.getStoreObjectMessage().subscribe((current) => {
      this.applyCurrentStore(current);
    });
    this.storeService.getAllStores().subscribe({
      next: (stores) => {
        this.stores = (stores || []).map((store) => {
          const rate = parseFloat(String(store.salesTaxRate ?? 0));
          return Object.assign({}, store, {
            salesTaxRate: isNaN(rate) || rate < 0 ? 0 : rate,
          });
        });
        this.applyCurrentStore(this.auth.getStoreObject());
      },
      error: () => {
        this.notification.show('error', 'Could not load locations');
      },
    });
  }

  ngOnDestroy(): void {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }

  suggestedRate(store: Store): string {
    const name = String(store?.storeName || '').toLowerCase();
    if (name.includes('mill valley')) {
      return '10';
    }
    if (name.includes('berkeley')) {
      return '10.25';
    }
    return '';
  }

  save(): void {
    const store = this.store;
    if (!store) {
      return;
    }
    const rate = Math.round(parseFloat(String(store.salesTaxRate)) * 100) / 100;
    if (isNaN(rate) || rate < 0 || rate > 100) {
      this.notification.show('error', 'Enter a sales tax rate from 0 to 100');
      return;
    }
    this.saving = true;
    this.storeService.updateSalesTaxRate(store._id, rate).subscribe({
      next: (saved) => {
        this.saving = false;
        store.salesTaxRate = saved?.salesTaxRate != null ? saved.salesTaxRate : rate;
        this.notification.show('success', `Sales tax saved for ${store.storeName}`);
      },
      error: (err) => {
        this.saving = false;
        this.notification.show('error', err?.error?.message || 'Could not save sales tax');
      },
    });
  }

  private applyCurrentStore(current: Store): void {
    const id = current && current._id;
    if (!id || !this.stores.length) {
      this.store = null;
      return;
    }
    this.store =
      this.stores.find((row) => String(row._id) === String(id)) || null;
  }
}
